import React from 'react';
import { Phone, ShieldAlert, CheckCircle2, Lock, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="bg-white pt-10 pb-12 md:pt-14 md:pb-16 px-4 sm:px-6 lg:px-8 border-b border-slate-100" data-id="element-78">
      <div className="max-w-7xl mx-auto" data-id="element-79">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start" data-id="element-80">
          {/* Left Column */}
          <div className="lg:col-span-7 flex flex-col" data-id="element-81">
            <div className="inline-flex items-center gap-2 bg-brand-redLight text-brand-red px-4 py-2 rounded-full text-sm font-semibold mb-7 w-fit border border-brand-redBorder" data-id="element-82">
              <span className="w-2 h-2 rounded-full bg-brand-red" data-id="element-83" />
              <span data-id="element-84">
                Broken Windshield Today? Same-Day Openings May Be Available
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 leading-[1.05] mb-6 tracking-tight" data-id="element-85">
              <span className="text-brand-red" data-id="element-86">
                Emergency Auto Glass Repair
              </span>{' '}
              <span className="text-slate-900" data-id="element-87">
                &amp; Windshield Replacement in
              </span>{' '}
              <span className="text-brand-red" data-id="element-88">Southeast Michigan</span>
            </h1>

            <p className="text-lg text-slate-600 mb-7 leading-relaxed max-w-2xl" data-id="element-89">
              Cracked windshield, shattered side window, broken rear glass or
              car door glass damage? Kosin's Glass provides urgent auto glass
              estimates, certified installation, insurance-claim help and
              same-day openings when available.
            </p>

            <ul className="space-y-3.5 mb-7" data-id="element-90">
              {['Windshield replacement, chip repair, side, door and rear window replacement', 'Same-day openings may be available depending on glass and schedule', 'Certified technicians using glass that meets or exceeds OEM standards', 'Insurance-claim help and lifetime vehicle glass workmanship warranty'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-91">
                  <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-brand-red flex items-center justify-center" data-id="element-92">
                    <CheckCircle2 className="w-3 h-3 text-brand-red" strokeWidth={3} data-id="element-93" />
                  </span>
                  <span className="text-slate-700" data-id="element-94">{bullet}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-3 mb-5" data-id="element-95">
              <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-96">
                <Phone className="w-5 h-5" data-id="element-97" />
                Call 517-545-7772 Now
              </a>
              <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-900 border border-slate-300 px-7 py-4 rounded-lg font-bold text-base transition-colors" data-id="element-98">
                Request Urgent Quote
                <ArrowRight className="w-4 h-4" data-id="element-99" />
              </a>
            </div>

            <p className="text-sm text-slate-500 mb-5" data-id="element-100">
              Serving Howell, Ann Arbor, Novi and Southeast Michigan.
            </p>

            <div className="bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 flex items-start gap-2.5 mb-3" data-id="element-101">
              <ShieldAlert className="w-4 h-4 text-slate-500 shrink-0 mt-0.5" data-id="element-102" />
              <p className="text-xs text-slate-600 leading-relaxed" data-id="element-103">
                If your visibility is blocked, glass is loose, or the vehicle
                feels unsafe to drive, do not continue driving. Call Kosin's
                Glass and the team will help you determine the safest next step.
              </p>
            </div>

            <div className="flex items-center gap-1.5 text-xs text-slate-500" data-id="element-104">
              <Lock className="w-3 h-3" data-id="element-105" />
              <span data-id="element-106">
                Your information is secure. Kosin's Glass will never share your
                details.
              </span>
            </div>
          </div>

          {/* Right Column: Form */}
          <div className="lg:col-span-5 w-full" id="quote-form" data-id="element-107">
            <div className="bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden" data-id="element-108">
              <div className="p-6 sm:p-8" data-id="element-109">
                <div className="inline-block bg-brand-red text-white px-3 py-1.5 text-xs font-bold uppercase tracking-wider mb-5 rounded" data-id="element-110">
                  Urgent Auto Glass Quote
                </div>
                <h2 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-111">
                  Request Emergency Auto Glass Help
                </h2>
                <p className="text-sm text-slate-600 leading-relaxed mb-6" data-id="element-112">
                  Submit your details and a Kosin's Glass team member will
                  contact you to confirm your vehicle, glass type, damage,
                  insurance information, location and today's availability.
                </p>

                <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-113">
                  <div data-id="element-114">
                    <label htmlFor="fullName" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-115">
                      Full Name
                    </label>
                    <input type="text" id="fullName" autoComplete="name" placeholder="John Smith" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-red/40 focus:border-brand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-116" />
                  </div>
                  <div data-id="element-117">
                    <label htmlFor="phone" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-118">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" autoComplete="tel" placeholder="(555) 123-4567" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-red/40 focus:border-brand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-119" />
                  </div>
                  <div data-id="element-120">
                    <label htmlFor="email" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-121">
                      Email Address
                    </label>
                    <input type="email" id="email" autoComplete="email" placeholder="john@email.com" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-red/40 focus:border-brand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-122" />
                  </div>

                  <button type="submit" className="w-full bg-brand-red hover:bg-brand-redHover text-white font-bold uppercase tracking-wide text-sm py-4 rounded-md mt-2 transition-colors shadow-sm flex justify-center items-center gap-2" data-id="element-123">
                    Request My Urgent Quote
                    <ArrowRight className="w-4 h-4" data-id="element-124" />
                  </button>
                </form>

                <div className="mt-6 pt-5 border-t border-slate-100 text-center" data-id="element-125">
                  <p className="text-sm text-slate-600" data-id="element-126">
                    Prefer to call?{' '}
                    <a href="tel:517-545-7772" className="inline-flex items-center gap-1.5 text-slate-900 font-bold hover:text-brand-red" data-id="element-127">
                      <Phone className="w-4 h-4 text-brand-red" data-id="element-128" />
                      517-545-7772
                    </a>
                  </p>
                  <p className="text-xs text-slate-400 mt-2" data-id="element-129">
                    We respect your privacy. Your details are safe with us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}